/**
 * Chuỗi hiển thị của trang Thông báo, chuông đầu trang và chức năng tỉnh gửi thông
 * báo xuống xã (hợp đồng A0 hồ sơ – thông báo, mục 5).
 */
export const viThongBao = {
  tieuDe: 'Thông báo',
  tab: {
    cuaToi: 'Thông báo của tôi',
    gui: 'Gửi thông báo',
    daGui: 'Đã gửi',
  },
  /** Nhãn loại thông báo theo `loai` (migration 055). */
  loai: {
    ban_tin_cho_duyet: 'Bản tin chờ duyệt',
    ban_tin_da_duyet: 'Bản tin đã duyệt',
    ban_tin_tra_lai: 'Bản tin bị trả lại',
    ban_tin_bi_huy: 'Bản tin bị huỷ',
    ban_tin_chia_se: 'Bản tin được chia sẻ',
    thiet_bi_mat_ket_noi: 'Thiết bị mất kết nối',
    thiet_bi_ket_noi_lai: 'Thiết bị kết nối lại',
    lich_phat_loi: 'Lịch phát lỗi',
    xuat_du_lieu_xong: 'Xuất dữ liệu xong',
    tai_khoan_dat_lai_mk: 'Đặt lại mật khẩu',
    tai_khoan_bi_khoa: 'Tài khoản bị khoá',
    thong_bao_tinh: 'Thông báo của tỉnh',
  } as Record<string, string>,
  mucDo: {
    thong_thuong: 'Thông thường',
    quan_trong: 'Quan trọng',
    khan: 'Khẩn',
  },
  cot: {
    stt: 'STT',
    loai: 'Loại',
    nguoiGui: 'Người gửi',
    noiDung: 'Nội dung',
    thoiDiem: 'Thời điểm',
    trangThai: 'Trạng thái',
  },
  heThong: 'Hệ thống',
  daDoc: 'Đã đọc',
  chuaDoc: 'Chưa đọc',
  loc: {
    trangThai: 'Trạng thái',
    tatCa: 'Tất cả',
    chuaDoc: 'Chưa đọc',
    loai: 'Loại',
    tatCaLoai: 'Tất cả loại',
    khoangNgay: 'Khoảng ngày',
    tuNgay: 'từ ngày',
    denNgay: 'đến ngày',
  },
  danhDauTatCa: 'Đánh dấu đã đọc tất cả',
  daDanhDauTatCa: 'Đã đánh dấu đọc {so} thông báo.',
  rongMoTa: 'Bạn chưa có thông báo nào.',
  loiDanhDau: 'Không đánh dấu được thông báo',
  /* ------------------------------ Chuông ------------------------------ */
  chuong: {
    tieuDeThongBao: 'Thông báo mới',
    tieuDeCongViec: 'Công việc nền',
    chuaCoThongBao: 'Không có thông báo nào',
    dangTai: 'Đang tải…',
    xemTatCa: 'Xem tất cả',
    nhanHuyHieu: '{so} thông báo chưa đọc',
  },
  /* ---------------------------- Gửi thông báo --------------------------- */
  gui: {
    tieuDe: 'Tiêu đề',
    noiDung: 'Nội dung',
    mucDo: 'Mức độ',
    diaBan: 'Địa bàn nhận',
    toanTinh: 'Toàn tỉnh (mọi xã)',
    chonXa: 'Chọn xã',
    goiYChonXa: '— Chọn xã nhận —',
    daChonXa: 'Đã chọn {so} xã',
    chonTatCa: 'Chọn tất cả',
    boChonTatCa: 'Bỏ chọn',
    timXa: 'Tìm xã…',
    nutGui: 'Gửi thông báo',
    dangGui: 'Đang gửi…',
    thieuTieuDe: 'Nhập tiêu đề thông báo.',
    thieuNoiDung: 'Nhập nội dung thông báo.',
    thieuDiaBan: 'Chọn ít nhất một xã nhận, hoặc chọn Toàn tỉnh.',
    xacNhanTieuDe: 'Gửi thông báo',
    xacNhanToanTinh: 'Gửi thông báo "{tieuDe}" tới mọi tài khoản của toàn bộ các xã trong tỉnh?',
    xacNhanXa: 'Gửi thông báo "{tieuDe}" tới mọi tài khoản của {so} xã đã chọn?',
    ghiChuXacNhan: 'Thông báo đã gửi không thu hồi được.',
    daGui: 'Đã gửi thông báo tới {so} người nhận.',
    loiGui: 'Không gửi được thông báo',
    gioiHanTieuDe: 'Tối đa 200 ký tự.',
    gioiHanNoiDung: 'Tối đa 4000 ký tự.',
  },
  /* ----------------------------- Lịch sử gửi ---------------------------- */
  daGui: {
    cot: {
      tieuDe: 'Tiêu đề',
      mucDo: 'Mức độ',
      diaBan: 'Địa bàn nhận',
      daDoc: 'Đã đọc / Số nhận',
      nguoiGui: 'Người gửi',
      thoiDiem: 'Thời điểm gửi',
    },
    rongMoTa: 'Chưa gửi thông báo nào.',
  },
};
